const categories = [
  {
    _id: '1',
    name: 'Study',
    sticker: '📚',
    title: 'Study smart. Do Good and the good life will follow.',
    subtitle: 'Keep going!',
  },
  {
    _id: '2',
    name: 'Work',
    sticker: '👨‍🚀',
    title: "Don't be busy. Be productive",
    subtitle: 'Shock Yourself!',
  },
  {
    _id: '3',
    name: 'Sleep',
    sticker: '💤',
    title: 'Sleep is the best meditation.',
    subtitle: 'Happy sleep!',
  },
  {
    _id: '4',
    name: 'Coding',
    sticker: '👨‍💻',
    title: 'while( ! (succeed = try() ) );',
    subtitle: 'Keep going!',
  },
  {
    _id: '5',
    name: 'Watching',
    sticker: '📺',
    title: 'You can observe a lot by just watching.',
    subtitle: 'Enjoy watching!',
  },
  {
    _id: '6',
    name: 'Listening',
    sticker: '🎧',
    title: 'Behind every favorite song, there is an untold story.',
    subtitle: 'Happy listening!',
  },
  {
    _id: '7',
    name: 'Reading',
    sticker: '📖',
    title: 'Reading is dreaming with open eyes.',
    subtitle: 'Just one more chapter',
  },
  {
    _id: '8',
    name: 'Chit-chat',
    sticker: '👋',
    title: 'Great satisfaction comes from sharing with others.',
    subtitle: 'Sharing is caring.',
  },
  {
    _id: '9',
    name: 'Gaming',
    sticker: '🎮',
    title: 'When life gets hard it means You just leveled up.',
    subtitle: 'Keep grow!',
  },
  {
    _id: '10',
    name: 'Dine',
    sticker: '🍽️',
    title: 'Nothing brings people together like good food.',
    subtitle: 'Enjoy Your meal!',
  },
  {
    _id: '11',
    name: 'Tea',
    sticker: '🍵',
    title: 'happiness is a cup of tea.',
    subtitle: 'Tea positive',
  },
  {
    _id: '12',
    name: 'Coffee',
    sticker: '☕',
    title: "Today's good mood is sponsored by coffee",
    subtitle: 'Happy a good day!',
  },
]

export default categories
